import { IonChip, IonCol, IonGrid, IonIcon, IonRow, IonText } from '@ionic/react';
import * as Icons from 'ionicons/icons';
import * as React from 'react';
import * as commonCss from '../../styles/common';

import { css } from '@emotion/react';
import { getDarkerShade } from '../../shared/color';

export interface HealthRecommendationProps {
  iconName: keyof typeof Icons;
  recommendationText: string;
  color: string;
}

const HealthRecommendation: React.FC<HealthRecommendationProps> = ({ iconName, recommendationText, color }) => {
  const icon = Icons[iconName];

  const darkerColor = getDarkerShade(color);
  const hrCss = {
    container: [
      commonCss.noPadding,
      css({
        margin: 0,
        backgroundColor: 'white',
        borderColor: color,
        width: '100%',
        pointerEvents: 'none',
      }),
    ],
    recommendationText: [
      css({
        textAlign: 'justify',
        wordBreak: 'break-word',
        hyphens: 'auto',
        color: darkerColor,
      }),
    ],
    recommendationContainer: [css({ margin: 'auto' })],
    icon: [
      css({
        fontSize: 52,
        minWidth: 52,
        color,
        padding: 2,
        ['--ionicon-stroke-width']: '45px',
      }),
    ],
  };

  return (
    <IonChip outline css={hrCss.container}>
      <IonGrid css={commonCss.noPadding}>
        <IonRow>
          <IonCol size="auto" css={commonCss.centered}>
            <IonIcon icon={icon} css={hrCss.icon} />
          </IonCol>
          <IonCol css={hrCss.recommendationContainer}>
            <IonText css={hrCss.recommendationText}>{recommendationText}</IonText>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonChip>
  );
};

export default HealthRecommendation;
